
import { Injectable } from '@angular/core';
import { HttpHelperService } from './http-helper.service';


import { environment } from '../../../environments/environment';
import { Subject } from 'rxjs';
import { Board, BoardStage, NewBoard } from '../entities/board.entity';

@Injectable({
  providedIn: 'root',
})
export class BoardsService {
  private baseUrl = environment.endpoint + '/boards';

  constructor(
    private httpHelperService: HttpHelperService,
  ) {
  }

  async createBoard(board: NewBoard) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/add-board`,
        { board }
      );
      if (result && result.response) {
        resolve(result.response);
      } else {
        reject('API ERROR');
      }
    });
  }

  async update(board: any) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/update-board`,
        { board }
      );
      if (result && result.response) {
        resolve(result.response);
      } else {
        reject('API ERROR');
      }
    });
  }

  async pinToBoard(boardRef: any) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/pin`,
        { board: boardRef }
      );
      if (result && result.response) {
        resolve(result.response);
      } else {
        reject('API ERROR');
      }
    });
  }

  async getBoard(boardUUID: any) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/get-board`,
        { boardUUID }
      );
      if (result && result.response) {
        if (result) {
          resolve(result.response);
        } else {
          resolve({});
        }
      } else {
        reject('API ERROR');
      }
    });
  }
  async getBoards(ownerUUID: string, stage: BoardStage, nextToken: any) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/get-boards`,
        { ownerUUID, stage, nextToken }
      );
      if (result && result.response) {
        if (result.response.items) {
          resolve(result.response);
        } else {
          resolve([]);
        }
      } else {
        reject('API ERROR');
      }
    });
  }

  async getMemberBoard(stage: BoardStage, nextToken: any) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/get-member-boards`,
        { stage, nextToken }
      );
      if (result && result.response) {
        if (result.response.items) {
          resolve(result.response);
        } else {
          resolve([]);
        }
      } else {
        reject('API ERROR');
      }
    });
  }
  async generateTitle(params: any) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/generate/title`,
        { ...params }
      );
      if (result && result.response) {
        if (result) {
          resolve(result.response);
        } else {
          resolve({});
        }
      } else {
        reject('API ERROR');
      }
    });
  }
  async generateSummary(boardUUID: string) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/generate/summary`,
        { boardUUID }
      );
      if (result && result.response) {
        if (result) {
          resolve(result.response);
        } else {
          resolve({});
        }
      } else {
        reject('API ERROR');
      }
    });
  }
  async search(searchTerm: any, cancelSignal?: Subject<void>) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/boards/search`,
        { searchTerm },
        undefined,
        cancelSignal
      ).catch((error) => {
        console.error(error);
        reject("An Error Occur!, Try again later.");
      });

      if (result && result.response) {

        resolve(result.response);

      } else {
        reject("An Error Occur!, Try again later.");
      }
    });
  }
  async ask(boardUUID: string, question: any, cancelSignal?: Subject<void>) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/ask`,
        { boardUUID, question },
        undefined,
        cancelSignal
      ).catch((error) => {
        console.error(error);
        reject("An Error Occur!, Try again later.");
      });

      if (result && result.response) {

        resolve(result.response);

      } else {
        reject("An Error Occur!, Try again later.");
      }
    });
  }
  async addChilds(params: { boardUUID: string, childFieldKey: string, items: any[]; }) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/add-childs`,
        { ...params }
      );
      if (result && result.response) {
        resolve(result.response);
      } else {
        reject('API ERROR');
      }
    });
  }

  async removeChilds(params: { boardUUID: string, childFieldKey: string, childPkName: string, items: any[]; }) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const result: any = await this.httpHelperService.requestPromise(
          'POST',
          `${this.baseUrl}/remove-childs`,
          { ...params }
        );
        if (result && result.response) {
          resolve(result.response);
        } else {
          reject('API ERROR');
        }
      } catch (error) {
        throw error;
      }
    });
  }

  async updateChilds(params: { boardUUID: string, childFieldKey: string, childPkName: string, item: any; }) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const result: any = await this.httpHelperService.requestPromise(
          'POST',
          `${this.baseUrl}/update-childs`,
          { ...params }
        );
        if (result && result.response) {
          resolve(result.response);
        } else {
          reject('API ERROR');
        }
      } catch (error) {
        throw error;
      }
    });
  }
  async getUsers() {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'GET',
        `${this.baseUrl}/users`,
      );
      if (result && result.response) {
        resolve(result.response);
      } else {
        reject('API ERROR');
      }
    });
  }
}
